const POINTS = [
  "Gratis og uforpligtende",
  "Op til 3 godkendte firmaer, ét anbefalet",
  "Alle er CVR-tjekket",
  "Se firmaerne med det samme",
  "Firmaet kontakter dig med et tilbud",
];

export function WizardSidebar() {
  return (
    <aside className="self-start md:sticky md:top-24">
      <div className="rounded border border-border bg-paper p-6">
        <h4 className="mb-3.5 font-mono text-xs font-medium uppercase tracking-[0.08em] text-ink-subtle">
          Sådan fungerer det
        </h4>
        <ul className="mb-4.5 flex flex-col text-sm text-ink">
          {POINTS.map((item, i, arr) => (
            <li
              key={item}
              className={`flex items-baseline gap-3 py-2 ${
                i < arr.length - 1 ? "border-b border-paper-2" : ""
              } before:shrink-0 before:text-[13px] before:font-semibold before:text-theme-accent before:content-['✓']`}
            >
              {item}
            </li>
          ))}
        </ul>
        <p className="text-[13px] leading-relaxed text-ink-muted">
          Du binder dig til ingenting ved at udfylde formularen. Du ser firmaerne med det samme, og
          kun ét firma kontakter dig med et tilbud. Du bestemmer selv, om du vil sige ja.
        </p>
      </div>
      <div className="mt-5 rounded border border-border bg-white p-5">
        <h4 className="mb-2.5 font-mono text-xs font-medium uppercase tracking-[0.08em] text-ink-subtle">
          Hjælp
        </h4>
        <p className="text-[13px] leading-relaxed text-ink-muted">
          Har du spørgsmål til formularen?
          <br />
          <br />
          Ring på{" "}
          <a href="tel:+4591309013" className="font-semibold text-ink">
            91 30 90 13
          </a>{" "}
          eller skriv til{" "}
          <a
            href="mailto:info@rengoeringidanmark.dk"
            className="text-link underline underline-offset-2"
          >
            info@rengoeringidanmark.dk
          </a>
          .
        </p>
      </div>
    </aside>
  );
}
